import { render, staticRenderFns } from "./RedeemManagementUseByDetailsScreen.vue?vue&type=template&id=f42d655e&scoped=true&"
import script from "./RedeemManagementUseByDetailsScreen.vue?vue&type=script&lang=js&"
export * from "./RedeemManagementUseByDetailsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42d655e",
  null
  
)

export default component.exports